import type { DraftBlock, DraftContent } from './types'
import { isValidUrl } from './utils'

const draftBlock = ({ data, text = '', type = '' }: DraftBlock) => {
  if (type === 'header-one') {
    return `<h1>${text}</h1>`
  }
  if (type === 'header-two') {
    return `<h2>${text}</h2>`
  }
  if (type === 'header-three') {
    return `<h3>${text}</h3>`
  }
  if (type === 'blockquote') {
    return `<blockquote class="wp-block-quote">${text}</blockquote>`
  }
  if (type === 'code-block') {
    return `<p><code>${text}</code></p>`
  }
  if (type === 'img' && data?.url) {
    return `<p><img src="${data.url}" alt="" style="width: 100%"/></p>`
  }
  if (isValidUrl(text)) {
    return `<p><a href="${text}">${text}</a></p>`
  }

  return `<p>${text}</p>`
}

export const draft = ({ blocks = [] }: DraftContent) =>
  `<!-- wp:paragraph -->${blocks.map(draftBlock).join('\n')}<!-- /wp:paragraph -->`
